import { inject } from 'mobx-react';
import { TemplateComponentProps } from 'experience-template-renderer-react';
import * as React from 'react';

import { SearchResultsStore } from 'stores/search-results-store';

import { CustomerNotifications } from 'components/common/customer-notifications';
import { NotificationLocationOnPage } from '__generated__/api';
import { z } from 'zod';

export interface CustomerNotificationTemplateComponentProps extends TemplateComponentProps {
  searchResults: SearchResultsStore;
}

export const CustomerNotificationTemplateComponent: React.FC<CustomerNotificationTemplateComponentProps> = inject('searchResults')(
  ({ templateComponent, searchResults }) => {
    const { config } = templateComponent;

    const searchCriteria = searchResults?.searchCriteria;
    const { regionId, startDate, endDate } = searchCriteria || {};

    const configSchema = z.object({
      location: z.nativeEnum(NotificationLocationOnPage),
    });
    const result = configSchema.safeParse(config);

    if (!result.success) {
      return null;
    }

    const { location } = result.data;

    return <CustomerNotifications location={location} regionId={regionId} startDate={startDate} endDate={endDate} />;
  }
);
